import { useState, useEffect } from 'react';
import { theme } from '../theme';
import { useIsMobile } from '../hooks/useMediaQuery';

const STATUS_COLORS = {
  PENDING:  '#facc15',
  APPROVED: theme.colors.success,
  DECLINED: theme.colors.error,
  ERROR:    theme.colors.textMuted,
};

function TransaccionesClientes({ token }) {
  const isMobile = useIsMobile();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const totalPages = Math.max(1, Math.ceil(total / 20));

  useEffect(() => {
    setLoading(true);
    fetch(`/api/pay/transactions?page=${page}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : { data: [], total: 0 })
      .then(d => { setData(d.data || []); setTotal(d.total || 0); })
      .finally(() => setLoading(false));
  }, [page, token]);

  return (
    <main style={{ padding: isMobile ? '1.2rem 0.8rem' : '2rem 1.5rem', maxWidth: '900px', margin: '0 auto' }}>
      <div style={{ backgroundColor: theme.colors.surface, borderRadius: '14px', border: `1px solid ${theme.colors.border}`, padding: isMobile ? '1.2rem' : '2rem', boxShadow: `0 4px 24px ${theme.colors.glowSubtle}` }}>
        <h1 style={{ color: theme.colors.primary, fontSize: '1.4rem', marginBottom: '1.5rem' }}>Transacciones de clientes</h1>

        {loading ? (
          <p style={{ color: theme.colors.textMuted, textAlign: 'center', padding: '2rem' }}>Cargando...</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.88rem' }}>
              <thead>
                <tr>
                  {['Teléfono', 'Monto', 'Estado', 'Fecha'].map(col => (
                    <th key={col} style={{ textAlign: 'left', padding: '10px 12px', borderBottom: `1px solid ${theme.colors.border}`, color: theme.colors.primary, fontWeight: '600', whiteSpace: 'nowrap' }}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr><td colSpan={4} style={{ textAlign: 'center', padding: '2rem', color: theme.colors.textMuted }}>Sin transacciones.</td></tr>
                ) : data.map(row => (
                  <tr key={row.id} style={{ borderBottom: `1px solid ${theme.colors.border}` }}>
                    <td style={{ padding: '9px 12px', color: theme.colors.text }}>{row.celular}</td>
                    <td style={{ padding: '9px 12px', color: theme.colors.text }}>${parseFloat(row.amount).toLocaleString('es-CO')}</td>
                    <td style={{ padding: '9px 12px' }}>
                      <span style={{
                        display: 'inline-block', padding: '3px 10px', borderRadius: '20px',
                        fontSize: '0.75rem', fontWeight: '700',
                        backgroundColor: `${STATUS_COLORS[row.status] || theme.colors.textMuted}22`,
                        color: STATUS_COLORS[row.status] || theme.colors.textMuted,
                        border: `1px solid ${STATUS_COLORS[row.status] || theme.colors.textMuted}`,
                      }}>
                        {row.status}
                      </span>
                    </td>
                    <td style={{ padding: '9px 12px', color: theme.colors.textMuted, whiteSpace: 'nowrap' }}>{new Date(row.created_at).toLocaleDateString('es-CO')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', marginTop: '1.2rem' }}>
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} style={{ padding: '6px 16px', borderRadius: '6px', border: `1px solid ${theme.colors.border}`, cursor: page === 1 ? 'not-allowed' : 'pointer', backgroundColor: 'transparent', color: page === 1 ? theme.colors.textMuted : theme.colors.text, fontSize: '0.88rem' }}>← Anterior</button>
          <span style={{ color: theme.colors.textMuted, fontSize: '0.88rem' }}>Página {page} de {totalPages}</span>
          <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages} style={{ padding: '6px 16px', borderRadius: '6px', border: `1px solid ${theme.colors.border}`, cursor: page === totalPages ? 'not-allowed' : 'pointer', backgroundColor: 'transparent', color: page === totalPages ? theme.colors.textMuted : theme.colors.text, fontSize: '0.88rem' }}>Siguiente →</button>
        </div>
      </div>
    </main>
  );
}

export default TransaccionesClientes;
